import { Root } from "firestar";
import CSConnect from "./";
import axios from 'axios'

export interface GiftType extends Root {
   name: string,
   brand: string,
   description: string,
   thumbnail: string
}

interface ShopifyProductType {
   id: string,
   title: string,
   description: string,
   image: {
      src: string,
   },
   images: {
      src: string
   }[],
   variants: {
      inventory_quantity: number,
      id: string,
      requires_shipping: boolean,
      inventory_management: null | string,
      price: string
   }[],
   options: {
      id: string,
      name: string,
      values: string[]
   }[],
   status: string | 'active',
   body_html: string
}

namespace Gifts {

   export type Gift = GiftType
   export type ShopifyProduct = ShopifyProductType

   export function getGiftsForCasino(collectionId: string) {
      return new Promise<ShopifyProduct[]>(async (resolve, reject) => {
         try {
            const baseUrl = CSConnect.getBaseUrl()
            const url = baseUrl + '/getProductsForCollectionId?collectionId=' + collectionId
            const response = await fetch(url, {
               method: 'GET',
            })
            const products = await response.json() as any[]
            const gifts = products.map(
               (p) => {
                  return {
                     ...p,
                     description: p.body_html
                  }
               }
            )
            resolve(gifts)
         } catch (error) {
            reject(error)
         }
      })
   }

   export function getGiftsWithProductIds(productIds?: string[], includeOutOfStock?: boolean) {
      return new Promise<ShopifyProduct[]>(async (resolve, reject) => {

         try {
            const baseUrl = CSConnect.getBaseUrl()
            const url = baseUrl + '/getProductsWithIds'
            const body = {
               productIds: productIds,
            }
            const response = await axios.post(url, body, {
               headers: {
                  'Content-Type': 'application/json',
                  'Accept': '*/*',
               }
            })

            const allGifts = (response.data ?? []) as ShopifyProductType[]
            let avilableGifts = allGifts

            if ((includeOutOfStock ?? false) == false) {
               avilableGifts = allGifts.filter((gift) => {
                  const variants = gift.variants ?? []
                  if (variants.length == 0) {
                     return false
                  }
                  const variant = variants[0]
                  if (variant.inventory_management == null) {
                     return true
                  }
                  if ((variant.inventory_quantity ?? 0) > 0) {
                     return true
                  }
                  return false
               })
            }
            resolve(avilableGifts)

         } catch (error) {
            reject(error)
         }
      })
   }
}

export default Gifts